import { Notify } from '@flexisaf/flexibull2';
import { put, takeLatest } from 'redux-saga/effects';
import { school_id } from 'utils/constants';
import httpClient from 'utils/http-client';
import { handleError } from '../../../utils/utils';
import { createStudentFail, createStudentSuccess, resetEverythingAction } from '../action';
import studentActionTypes from '../types';

export function* createStudent({ payload }) {
  const { data, callback } = payload;
  const formData = data;
  try {
    const response = yield httpClient.post(`/students`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-TENANT-ID': `${school_id}`,
      },
    });
    yield put(createStudentSuccess(response.data));
    Notify('Student created successfully', { position: 'top-right' });
    yield put(resetEverythingAction());
    if (callback) {
      yield callback();
    }
  } catch (error) {
    yield put(createStudentFail(error?.message));
    const err = handleError(error);
  }
}

export function* onCreateStudentStart() {
  yield takeLatest(studentActionTypes.CREATE_STUDENT_START, createStudent);
}
